import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            filter: '',
            tabIndex: 0,
            openEditAddressValue: false,
            openEditRegionValue: false,
            openAddAddressValue: false,
            openAddRegionValue: false,
            regionToEdit: null,
            addressToEdit: null,
            regions: [],
            addresses: [],
        }
    },
    computed: {
        filteredRegions() {
            return this.regions.filter(item => {
                return item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.price.toString().toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
            })
        },
        filteredAddresses() {
            return this.addresses.filter(item => {
                return item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.neighborhood.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.neighborhood.price.toString().toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
            })
        }
    },
    methods: {
        getRegions: getRegions,
        getAddresses: getAddresses,
        deleteRegion: deleteRegion,
        deleteAddress: deleteAddress,
        getModuleStyle: getModuleStyle,
        setTab: setTab,
        keymonitor: keymonitor,
        clickSearch: clickSearch,
        visibleDel: visibleDel,
        openEditRegion: openEditRegion,
        openAddRegion: openAddRegion,
        openEditAddress: openEditAddress,
        openAddAddress: openAddAddress,
        compareActive(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareOrders(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },

    },
    created(){
        let _self = this;

        this.$topnavbar.$on('closeEditRegion', () => {
            _self.openEditRegionValue = false;
            _self.openAddRegionValue = false;
        });

        this.$topnavbar.$on('successEditRegion', () => {
            _self.openEditRegionValue = false;
            swal('Uspešno', 'Uspešno ažuriran region.', 'success')
            _self.getRegions();
            _self.getAddresses();
        });

        this.$topnavbar.$on('successAddRegion', () => {
            _self.openAddRegionValue = false;
            swal('Uspešno', 'Uspešno dodat region.', 'success')
            _self.getRegions();
            _self.getAddresses();
        });

        //Address
        this.$topnavbar.$on('closeEditAddress', () => {
            _self.openEditAddressValue = false;
            _self.openAddAddressValue = false;
        });

        this.$topnavbar.$on('successEditAddress', () => {
            _self.openEditAddressValue = false;
            swal('Uspešno', 'Uspešno ažurirana adresa.', 'success')
            _self.getAddresses();
        });

        this.$topnavbar.$on('successAddAddress', () => {
            _self.openAddAddressValue = false;
            swal('Uspešno', 'Uspešno dodata adresa.', 'success')
            _self.getAddresses();
        });

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.getRegions();
        this.getAddresses();
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
    }
}

function openEditAddress(address) {
    this.openEditAddressValue = true;
    this.addressToEdit = address;
}

function openEditRegion(region) {
    this.openEditRegionValue = true;
    this.regionToEdit = region;
}

function openAddRegion() {
    this.openAddRegionValue = true;
}

function openAddAddress() {
    this.openAddAddressValue = true;
}

function clickSearch() {
    // this.pagination.page = 1;
    // this.getDrivers()
}

function getRegions() {
    var _self = this;
    AdminApiService.getRegions()
        .then((response) => {
            _self.regions = response.data;
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getAddresses() {
    var _self = this;
    AdminApiService.getAddresses()
        .then((response) => {
            _self.addresses = response.data;
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getVehicles();
    }
}



function deleteRegion(item) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrišete region " + item.name + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.deleteRegion(item.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali region.', 'success')
                _self.getRegions();
                _self.getAddresses();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });
}

function deleteAddress(item) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrišete adresu " + item.name + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.deleteAddress(item.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali adresu.', 'success')
                _self.getAddresses();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });
}


function getModuleStyle(index) {
    if(index === this.tabIndex){
        return "background: #70b1e7; color: white;"
    }else {
        return "background: #1b1e24; color: white;"
    }
}

function setTab(tab) {
    this.tabIndex = tab;
}
function visibleDel() {
    return true;
    // return localStorage.getItem('sb95') === 'braca'
}


// WEBPACK FOOTER //
// ./src/components/Price/Price.js